import { smallHeadingAndTextStyles as styles } from "@insite/content-library/Components/SmallHeadingAndText";
import { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const commonHeading: TypographyProps = {
    variant: "p",
    weight: 700,
    color: colorStrings.commonGlobalGrayText,
    css: css`
        ${styles.heading?.css}
        margin: 0;
    `,
};

export const commonText: TypographyProps = {
    variant: "p",
    weight: 400,
    color: colorStrings.commonGlobalGrayText,
    css: css`
        ${styles.text?.css}
        margin: 0;
    `,
};

styles.heading = {
    ...styles.heading,
    ...commonHeading,
};

styles.text = {
    ...styles.text,
    ...commonText,
};
